import cookie from 'js-cookie';

/**
 * JsCookies Encodes the Cookie Values by default, to maintain the backward compatibility with Foobunny Cookies we need to override that.
 * @TODO Once Foobunny is completly Depricated then we can remove this.
 *
 */
const cookieWithConverter = cookie.withConverter({
  write: (value) => encodeURIComponent(value),
  read: (value) => decodeURIComponent(value),
});

class CookiesClient {
  /**
   * Get the Cookie value.
   * @param cookieName [string] The Name of the cookie that has to be returned.
   * @returns cookieValue [string] The String value of the cookie corresponding to the name.
   *
   */
  get(cookieName) {
    if (cookieName) {
      return cookieWithConverter.get(cookieName);
    }
  }

  /**
   * Method to get the JSON Cookie value.
   * @param cookieName [string] The Name of the cookie that has to be returned.
   * @returns cookieValue [object] The object representation of the cookie corresponding to the name.
   *
   */
  getJSON(cookieName) {
    let cookieValue = this.get(cookieName);

    try {
      if (cookieValue) {
        cookieValue = JSON.parse(cookieValue);
      }
    } catch (e) {
      /* istanbul ignore next */
      const {logger} = this;
      /* istanbul ignore next */
      if (logger) {
        logger.error(e);
      }
    }

    return cookieValue;
  }

  /**
   * Method to set the Cookie value.
   * @param cookieName [string] The Name of the cookie that has to be returned.
   * @param cookieValue [string] The String value of the cookie corresponding to the name.
   * @param cookieOptions [object={}] The option to be used while setting the cookies.
   *
   */
  set(cookieName, cookieValue, cookieOptions) {
    if (cookieName) {
      cookieWithConverter.set(cookieName, cookieValue, cookieOptions);
    }
  }

  /**
   * Method to set the JSON Cookie value.
   * @param cookieName [string] The Name of the cookie that has to be returned.
   * @param cookieValue [object] The object representation of the cookie corresponding to the name.
   * @param cookieOptions [object] The option to be used while setting the cookies.
   *
   */
  setJSON(cookieName, cookieValue, cookieOptions) {
    if (cookieName) {
      let cookieJsonString = cookieValue;
      if (typeof cookieValue === 'object') {
        cookieJsonString = JSON.stringify(cookieValue);
      }
      this.set(cookieName, cookieJsonString, cookieOptions);
    }
  }

  /**
   * Method to Remove the Cookie
   * @param cookieName [string] The Name of the cookie that has to be returned.
   * @param cookieOptions [object] The option to be used while setting the cookies.
   *
   */
  remove(cookieName, cookieOptions = {}) {
    if (cookieName) {
      cookieWithConverter.remove(cookieName, cookieOptions);
    }
  }
}

export default CookiesClient;
export const client = new CookiesClient();
